module.exports = __webpack_public_path__ + "media/images/emblems/Seuzach-blazon-3cc802b1bb22dc5585f129aa510aa818.svg";